var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-jumbotron',{staticClass:"pb-4 pt-4",attrs:{"border-variant":"dark","bg-variant":"transparent"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('runCommentTitle')))]),_c('app-comment',{ref:"appComment",attrs:{"comments":_vm.comments},on:{"input":function($event){_vm.nonCommittedComment = $event},"save":_vm.saveComment}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }